import { useEffect } from 'react';
import styled from 'styled-components';
import frontVersion from '../gen/front-version.json';
import { useHealth } from '../hooks/useHealth';

const Footer = styled.footer`
  position: fixed;
  left: 0;
  bottom: 0;
  color: gray;
  text-align: center;
  width: 100vw;
  opacity: 0.5;
  pointer-events: none;
  z-index: 2;
`;

export const VersionInfo = () => {
  const { data } = useHealth();
  const infoString = `front: ${frontVersion.sha} - ${frontVersion.date} -- back: ${data?.version} -- env: ${data?.environment}`;

  useEffect(() => console.log(infoString), [infoString]);

  if (data?.environment?.toLocaleLowerCase().startsWith('prod')) {
    return null;
  }

  return <Footer>{infoString}</Footer>;
};
